import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  AuthService,
  FirebaseAnalyticsService,
  SharedService,
  UserAccountService,
} from "@modules/core";
import { Subscription } from "rxjs";

@Component({
  selector: "app-logged-in-oidc",
  templateUrl: "./logged-in-oidc.component.html",
  styleUrls: ["./logged-in-oidc.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoggedInOidcComponent implements OnInit, OnDestroy {
  subscription: Subscription | null = null;

  constructor(
    private authService: AuthService,
    private sharedService: SharedService,
    private userAccountService: UserAccountService,
    private analytics: FirebaseAnalyticsService
  ) {}

  ngOnInit() {
    this.subscription = this.authService.userId$.subscribe({
      next: (userId) => {
        if (userId === null) return;
        this.userAccountService.userFirstInsideTheApp(userId);
        this.analytics.logEvent("login");
        this.analytics.logEvent("login_custom");
        this.analytics.logEvent("sign_in");
        this.analytics.logEvent("login");
      },
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
